//generate 100 random numbers between 0 and 3
const makeRandom = () => Math.random() * 3;
const randomArray = [];
for (let i = 0; i <= 100; i++) {
  randomArray.push(makeRandom());
}
// pick from that list based on index
export const randomNumber = (i) => {
  //indexes above 100 use the pre-100 numbers
  if (i > 100) i = i % 100;
  return randomArray[i];
};
